// @owners { team: patients }
import { ActionSheetContext, Button } from '@alto/design-system';
import React, { useContext } from 'react';
import { CreditCardActionSheet } from '~web/features/payments/components/CreditCardActionSheet';

export const AddPaymentMethodButton = () => {
  const { setActiveActionSheet } = useContext(ActionSheetContext);

  return (
    <Button
      type="primary"
      label="Add payment method"
      accessibilityLabel="Press to add payment method"
      onPress={() => {
        setActiveActionSheet(<CreditCardActionSheet />);
      }}
      iconLeftName="plus-small"
    />
  );
};
